import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import ScrollButton from '../shared/ScrollButton';
import GlobalErrorBoundary from '../shared/GlobalErrorBoundary';
import { FocusRestorer } from '../shared/FocusRestorer';

const MainLayout = () => {
    // Note: Footer and ScrollButton now access cookieBannerHeight directly from NavigationProvider
    return (
        <div className="relative bg-background text-text min-h-screen flex flex-col">
            <FocusRestorer />
            <Header />
            <main className="flex-grow">
                <GlobalErrorBoundary>
                    <Outlet />
                </GlobalErrorBoundary>
            </main>
            <Footer />
            <ScrollButton />
        </div>
    );
};

export default MainLayout;
